import MobileRedirect from './MobileRedirect';

export default MobileRedirect;
